import { ToastrService } from 'ngx-toastr';
import { Injectable } from '@angular/core';
import { environment } from '../../environment/environment';
import { DataService } from './data.service';

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  isController: boolean = environment.isController;

  constructor(
    private toastr: ToastrService,
    private dataService: DataService
  ) {}

  info(msg: string, title?: string) {
    if (this.isController) {
      this.showOnNotificationBar('info', msg);
    } else {
      this.toastr.info(msg, title);
    }
  }

  success(msg: string, title?: string) {
    if (this.isController) {
      this.showOnNotificationBar('success', msg);
    } else {
      this.toastr.success(msg, title);
    }
  }
  error(msg: string, title?: string) {
    if (this.isController) {
      this.showOnNotificationBar('error', msg);
    } else {
      this.toastr.error(msg, title);
    }
  }
  showOnNotificationBar(msgType: string, msg: string) {
    this.dataService.notificationBar.next({ msgType, msg });
  }
}
